import React from 'react';
import LogClock from '/public/icons/log-clock.svg';

const LOG_CLOCK_VIEW_BOX = '0 0 57 51';

export function AuditLogsEmptyState() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center py-20 text-center gap-2 max-md:gap-3.5 max-md:py-4">
      <LogClock viewBox={LOG_CLOCK_VIEW_BOX} className="max-md:size-15" />
      <div className="flex flex-col items-center gap-2">
        <h3 className="light text-black max-md:text-lg max-md:leading-[122%] max-md:tracking-[0.006em]">
          No activity yet
        </h3>
        <p className="text-body-regular text-grey-700 max-md:!text-sm max-md:!leading-[150%]">
          Changes to this client profile will appear here once updates are made.
        </p>
      </div>
    </div>
  );
}
